// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".image-carousel__control[data-v-42e7ceff]{backdrop-filter:blur(2px);border:1px solid hsla(0,0%,100%,.1)}", ""]);
// Exports
module.exports = exports;
